import { OrderData } from '../types/api';
import axios from 'axios';
// Import the configured apiClient from auth.ts
import { apiClient } from './auth';

// Define a type for API response with orderId
export interface OrderResponse {
  id?: number;
  orderId?: string;
}

// Order details response interface
export interface OrderDetailsResponse {
  id: string;
  orderNumber?: string;
  email: string;
  customerId?: string | number;
  subtotal: number;
  subtotalWithoutTax: number;
  total: number;
  totalWithoutTax: number;
  tax: number;
  items: Array<{
    id: number;
    productId: number;
    price: number;
    priceWithoutTax: number;
    productPrice: number;
    sku: string;
    quantity: number;
    shortDescription: string;
    tax: number;
    shipping: number;
    name: string;
    imageUrl: string;
    taxes: Array<{
      name: string;
      value: number;
      total: number;
      taxOnDiscountedSubtotal: number;
      taxOnShipping: number;
    }>;
    attributes?: Array<{
      name: string;
      value: string;
    }>;
  }>;
  paymentStatus: string;
  paymentMethod: string;
  fulfillmentStatus: string;
  orderComments?: string;
  customSurcharges?: Array<{
    id: string;
    value: number;
    total: number;
    description: string;
    taxable: boolean;
    taxes: Array<any>;
  }>;
  shippingOption?: {
    shippingMethodName: string;
    shippingRate: number;
    isPickup: boolean;
    fulfillmentType: string;
  };
  billingPerson?: {
    name: string;
    firstName: string;
    lastName: string;
    street: string;
    city: string;
    countryCode: string;
    countryName: string;
    postalCode: string;
    stateOrProvinceCode: string;
    stateOrProvinceName: string;
    phone: string;
  };
  shippingPerson?: {
    name: string;
    firstName: string;
    lastName: string;
    street: string;
    city: string;
    countryCode: string;
    countryName: string;
    postalCode: string;
    stateOrProvinceCode: string;
    stateOrProvinceName: string;
    phone: string;
  };
  createDate?: string;
  updateDate?: string;
  taxes?: Array<{
    name: string;
    value: number;
    total: number;
  }>;
}

export const createOrder = async (orderData: OrderData, customHeaders = {}): Promise<OrderResponse> => {
  const url = `/orders`;
  
  const headers = {
    ...customHeaders
  };
  
  console.log('Sending order to:', url);
  console.log('Order data:', JSON.stringify(orderData));
  
  const response = await apiClient.post(url, orderData, { headers });
  return response.data;
};

export const getOrderById = async (orderId: string): Promise<OrderDetailsResponse> => {
  const url = `/orders/${orderId}`;
  
  const headers = {
  };
  
  console.log('Fetching order details from:', url);
  
  try {
    const response = await apiClient.get(url, { headers });
    console.log('Order details response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching order details:', error);
    throw error;
  }
};

// Get all orders for the current user
export const getUserOrders = async (limit: number = 10, offset: number = 0): Promise<any> => {
  try {
    const response = await apiClient.get('/orders', {
      params: { limit, offset }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user orders:', error);
    throw error;
  }
}; 